var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 227 244.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #676767;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #f69220;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-5 {\n        fill: #92298d;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 117,
    cy: 110,
    r: 110
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "77.6 -5 49.16 -5 49.16 -4.96 157.92 110.26 49.16 224.74 49.16 225 77.6 225 186.5 110.37 77.6 -5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "25.01 -5 -3.44 -5 -3.44 -4.96 105.32 110.26 -3.44 224.74 -3.44 225 25.01 225 133.91 110.37 25.01 -5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "-27.59 -5 -56.03 -5 -56.03 -4.96 52.73 110.26 -56.03 224.74 -56.03 225 -27.59 225 81.31 110.37 -27.59 -5"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.41,110.15C218.41,49.84,169.51.95,109.2.95S0,49.84,0,110.15s48.89,109.2,109.2,109.2c19.17,0,37.17-4.95,52.83-13.63l23.49,38.66,20.02-14.71c-8.37-11.39-18.27-22.83-28.13-34.27,24.98-20.01,40.99-50.75,40.99-85.25Zm-109.2,93.29c-51.52,0-93.29-41.77-93.29-93.29S57.68,16.86,109.2,16.86s93.29,41.77,93.29,93.29c0,29.66-13.85,56.06-35.43,73.15-5.69-6.75-11.17-13.5-16.12-20.23,0,0-8.68,10.12-8.68,10.12l11.5,18.93c-13.24,7.22-28.43,11.32-44.57,11.32Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBar);
export default __webpack_public_path__ + "static/media/SearchBar.0036ba96ebe952961298ef8b161664df.svg";
export { ForwardRef as ReactComponent };